var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIdentifiers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.25,
    stroke: "#0D0D0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99707 4.25C6.96199 4.25 7.74404 5.03217 7.74414 5.99707V7.7207C7.74414 7.94099 7.56597 8.12007 7.3457 8.12012H6.18457C5.11609 8.11987 4.25 7.2531 4.25 6.18457V5.99707C4.2501 5.03224 5.03224 4.2501 5.99707 4.25Z",
    stroke: "#295EF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0029 4.25C13.038 4.25 12.256 5.03217 12.2559 5.99707V7.7207C12.2559 7.94099 12.434 8.12007 12.6543 8.12012H13.8154C14.8839 8.11987 15.75 7.2531 15.75 6.18457V5.99707C15.7499 5.03224 14.9678 4.2501 14.0029 4.25Z",
    stroke: "#295EF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0029 15.75C13.038 15.75 12.256 14.9678 12.2559 14.0029L12.2559 12.2793C12.2559 12.059 12.434 11.8799 12.6543 11.8799L13.8154 11.8799C14.8839 11.8801 15.75 12.7469 15.75 13.8154L15.75 14.0029C15.7499 14.9678 14.9678 15.7499 14.0029 15.75Z",
    stroke: "#295EF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99707 15.75C6.96199 15.75 7.74404 14.9678 7.74414 14.0029L7.74414 12.2793C7.74414 12.059 7.56597 11.8799 7.3457 11.8799L6.18457 11.8799C5.11609 11.8801 4.25 12.7469 4.25 13.8154L4.25 14.0029C4.2501 14.9678 5.03224 15.7499 5.99707 15.75Z",
    stroke: "#295EF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71631 7.56226L7.71631 12.4149",
    stroke: "#295EF1",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2876 7.56226L12.2876 12.4156",
    stroke: "#295EF1",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7622 8.01538L7.29537 8.02121",
    stroke: "#295EF1",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2876 11.9464L7.29485 11.9464",
    stroke: "#295EF1",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdentifiers);
export default __webpack_public_path__ + "static/media/icon-identifiers.1bdeb7a1a1d59c9a8f950487a82d979e.svg";
export { ForwardRef as ReactComponent };